export interface HudState {
  health: number
  armor: number
  ammo: number
  reserve: number
  weapon: string
  team: string
  /** Melee weapons (knife) carry no ammo, so the ammo counter is hidden. */
  melee: boolean
}

/** Thin wrapper over the static HUD markup in index.html. Updates on change. */
export default class Hud {
  private readonly el = {
    health: document.getElementById('hud-health'),
    armor: document.getElementById('hud-armor'),
    ammo: document.getElementById('hud-ammo'),
    reserve: document.getElementById('hud-reserve'),
    weapon: document.getElementById('hud-weapon'),
    team: document.getElementById('hud-team'),
    ammoBox: document.querySelector<HTMLElement>('.hud__ammo'),
  }
  private readonly last: Record<string, string> = {}

  public setVisible(visible: boolean): void {
    document.getElementById('hud')?.classList.toggle('hidden', !visible)
  }

  public update(state: HudState): void {
    this.set('health', this.el.health, String(state.health))
    this.set('armor', this.el.armor, String(state.armor))
    this.set('ammo', this.el.ammo, String(state.ammo))
    this.set('reserve', this.el.reserve, String(state.reserve))
    this.set('weapon', this.el.weapon, state.weapon)
    this.set('team', this.el.team, state.team)
    this.el.ammoBox?.classList.toggle('hidden', state.melee)
  }

  private set(
    key: keyof HudState,
    el: HTMLElement | null,
    value: string,
  ): void {
    if (!el || this.last[key] === value) return
    this.last[key] = value
    el.textContent = value
  }
}
